var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup821(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 33,
    viewBox: "0 0 71 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.1384 30.3256H38.8618L33.0746 26.593V10.3047L68.1384 30.3256Z",
    fill: "#D6AF66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0321 28.9682L19.1172 5.89355L33.0746 10.3047M33.0746 10.3047L68.1384 30.3255H38.8618L33.0746 26.593V10.3047ZM19.1172 5.89355L22.181 28.9682",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.032 7.25044C12.032 8.5104 11.5299 9.71876 10.6361 10.6097C9.74228 11.5006 8.53004 12.0011 7.26603 12.0011C6.00202 12.0011 4.78977 11.5006 3.89598 10.6097C3.00219 9.71876 2.50007 8.5104 2.50007 7.25044C2.50007 5.99048 3.00219 4.78212 3.89598 3.89119C4.78977 3.00026 6.00202 2.49974 7.26603 2.49974C8.53004 2.49974 9.74228 3.00026 10.6361 3.89119C11.5299 4.78212 12.032 5.99048 12.032 7.25044Z",
    fill: "#D6AF66",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup821);
export default __webpack_public_path__ + "static/media/Group 82 (1).c59c9fb46e78047c99c24fe9dc3681d8.svg";
export { ForwardRef as ReactComponent };